import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CategoryResultsAverageBuilder } from '../../models/builder/category-results-average.builder';
import { PollBuilder } from '../../models/builder/poll.builder';
import { Poll } from '../../models/poll';

@Injectable()
export class PollApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.companyAdmin.apiUrl}polls`;
  }

  getPoll(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(map(PollBuilder.fromJson));
  }

  createPoll(pollBody): Observable<Poll> {
    return this.httpClient.post(`${this.apiUrl}`, pollBody)
      .pipe(
        map(PollBuilder.fromJson)
      );
  }

  updatePoll(pollBody, hash) {
    return this.httpClient.put(`${this.apiUrl}/${hash}`, pollBody)
      .pipe(
        map(PollBuilder.fromJson)
      );
  }

  publishPoll(hash: string) {
    return this.httpClient.put(`${this.apiUrl}/${hash}/publish`, null)
      .pipe(
        map(PollBuilder.fromJson)
      );
  }

  deletePoll(hash: string) {
    return this.httpClient.delete(`${this.apiUrl}/${hash}`)
      .pipe(
        map(PollBuilder.fromJson)
      );
  }

  downloadPollQR(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}/QR`, { responseType: 'arraybuffer' });
  }

  downloadPollResults(hash, locale?: string) {
    const url = locale ? `${this.apiUrl}/${hash}/pdf?locale=${locale}` : `${this.apiUrl}/${hash}/pdf`;
    return this.httpClient.get(url, { responseType: 'arraybuffer' });
  }

  getPollResults(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}/results`)
      .pipe(
        map(CategoryResultsAverageBuilder.fromList)
      );
  }
}
